import script from "./TrackerProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TrackerProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./TrackerProjectInfo.vue?vue&type=style&index=0&id=1fcaa4f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcaa4f8"]])

export default __exports__